import { render, staticRenderFns } from "./HsabExpenseCardRowPayment.vue?vue&type=template&id=4495b5a2&scoped=true"
import script from "./HsabExpenseCardRowPayment.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRowPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495b5a2",
  null
  
)

export default component.exports